import { useEffect, useState } from 'react';

const STAGES = [
  { id: 1, label: 'Searching the web…' },
  { id: 2, label: 'Extracting sources…' },
  { id: 3, label: 'Synthesizing insights…' },
  { id: 4, label: 'Generating final output…' },
];

const DeepResearchProgress = ({ isActive }) => {
  const [stageIndex, setStageIndex] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setStageIndex(0);
      return;
    }

    setStageIndex(0);

    const timers = [
      setTimeout(() => setStageIndex(1), 1200),
      setTimeout(() => setStageIndex(2), 2600),
      setTimeout(() => setStageIndex(3), 4200),
    ];

    return () => timers.forEach(clearTimeout);
  }, [isActive]);

  if (!isActive) return null;

  return (
    <div className="mt-6 rounded-xl border border-white/10 bg-white/5 p-4 space-y-3">
      {STAGES.map((stage, index) => {
        const isDone = index < stageIndex;
        const isActiveStage = index === stageIndex;

        return (
          <div
            key={stage.id}
            className={`text-sm transition-all ${
              isDone
                ? 'text-accent-teal'
                : isActiveStage
                ? 'text-white font-medium'
                : 'text-neutral-silver'
            }`}
          >
            {isDone ? '✓ ' : isActiveStage ? '→ ' : '• '}
            {stage.label}
          </div>
        );
      })}
    </div>
  );
};

export default DeepResearchProgress;
